import * as React from "react";
import * as cls from "./Nav.module.scss";
import { Action } from "./Action.js";
import { Icon } from "./Icon.jsx";
export { Nav };
/**
 * Меню навигации.
 * 
 * Константы:
 * - `Accessibility.OPEN`: пункт меню "Средства доступности"
 *    для перехода в режим доступности.
 * - `OTRS.OPEN`: пункт меню "Поддержка"
 *    для создания обращения в службу поддержки.
 * 
 * @summary Меню навигации.
 * @param {Object} props - Атрибуты элемента.
 * @param {Action[]} [props.menu] - Элементы меню. 
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <Nav menu={[...other_menu, OTRS.OPEN, Accessibility.OPEN]}/>
 * @example
 * <Nav menu={[
 *   {
 *     name: "Домой", // название
 *     icon: "home", // имя иконки
 *     href: "https://roweb.online/personal", // адрес ссылки
 *     target: "_blank", // если нужно открывать на новой вкладке
 *     onClick: (event) => {event.preventDefault();} // обработчик нажатия
 *   },
 * ]}
 * @see {@link Icon.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Nav({ menu = [] }) {
  const content = [];
  for (const menuItem of menu) {
    const action = new Action(menuItem);
    const name = action.name;
    const icon = action.icon || "question";
    const attrs = action.getAnchorAttributes();
    const className = action.delimiter ? cls.nav_delimiter : undefined;
    const badge = <NavBadge value={action.badge} />;
    content.push(
      <li key={name} role='none'>
        <a title={name} aria-label={name} {...attrs} className={className}>
          <Icon name={icon} className={cls.nav_icon} />{badge}
        </a>
      </li>
    );
  }
  return <ul className={cls.navbar_nav}>{content}</ul>;
}
/**
 * Бейдж для иконки с счётчиком. 
 * @param {Object} props - Атрибуты элемента.
 * @param {string} [props.value] - Значение счётчика. 
 * @returns {JSX.Element} Элемент JSX.
 */
function NavBadge({ value }) {
  if (!value) return null;
  return <span className={cls.nav_badge}>{value}</span>;
}
